$("a").each(function (t, n) {
    var e = $(this);
    void 0 !== e.attr("href") && -1 != e.attr("href").indexOf("https://app.five9.com/consoles/ChatConsole") ? (e.attr("data-open", "popup"), e.attr("data-name", "Live Chat"), e.attr("data-width", "500"), e.attr("data-height", "600"), e.animate({'opacity': 0}, 0)) : void 0 !== e.attr("href") && -1 != e.attr("href").indexOf("https://crc.wd1.myworkdayjobs.com/CRCExternal") ? (e.attr("data-open", "popup"), e.attr("data-name", "Careers"), e.attr("data-width", "1000"), e.attr("data-height", "750"), e.animate({'opacity': 0}, 0)) : void 0 !== e.attr("href") && -1 != e.attr("href").indexOf("https://www.google.com/maps/") ? (e.attr("data-open", "popup"), e.attr("data-name", "Maps"), e.attr("data-width", "1000"), e.attr("data-height", "750"), e.animate({'opacity': 0}, 0)) : void 0 !== e.attr("href") && -1 != e.attr("href").indexOf("https://app.etapestry.com/hosted") ? (e.attr("data-open", "popup"), e.attr("data-name", "Online Giving"), e.attr("data-width", "1000"), e.attr("data-height", "750"), e.animate({'opacity': 0}, 0)) : void 0 !== e.attr("href") && -1 != e.attr("href").indexOf("resources.") && (e.attr("data-open", "popup"), e.attr("data-name", "Resources"), e.attr("data-width", "1200"), e.attr("data-height", "750"), e.animate({'opacity': 0}, 0))
});

$(document).ready(function () {
    $('[data-open="popup"]').animate({
        'opacity': 1
    }, 300);
});

document.addEventListener('DOMContentLoaded', function () {
    $('[data-open="popup"]').off("click");
    $('[data-open="popup"]').on('click', function (e) {

        e.preventDefault();
        e.stopPropagation();

        var ele = $(this);

        if(window.outerWidth > 640){
            window.open(ele.attr("href"), ele.data("name"), "width=" + ele.data("width") + ",height=" + ele.data("height") + ",scrollbars=1");
        } else {
            window.open(ele.attr("href"), '_blank');
        }

    });
});